import { render, staticRenderFns } from "./model_70.vue?vue&type=template&id=264da71f&scoped=true"
import script from "./model_70.vue?vue&type=script&lang=js"
export * from "./model_70.vue?vue&type=script&lang=js"
import style0 from "./model_70.vue?vue&type=style&index=0&id=264da71f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264da71f",
  null
  
)

export default component.exports